import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { QuickQuestions } from './components/QuickQuestions';
import { FilterSidebar } from './components/FilterSidebar';
import { CompanyDirectory } from './components/CompanyDirectory';
import { TooltipProvider } from './components/ui/Tooltip';
export function App() {
  useEffect(() => {
    document.title = 'visibility.is — Look behind the curtain before you join a company';
    const metaTags: Record<string, string> = {
      description: 'Bridge the gap between PR/recruiting pitches and workplace reality. Research employer values, DEI commitment, benefits, political donations, and employee sentiment.',
      'og:title': 'visibility.is — Look behind the curtain before you join a company',
      'og:description': 'Bridge the gap between PR/recruiting pitches and workplace reality. Research employer values, DEI commitment, benefits, political donations, and employee sentiment.',
      'og:image': 'https://cdn.magicpatterns.com/uploads/nXQwxbHUw9VppBjvNZBCE4/favicon.png',
      'og:type': 'website',
      'og:url': 'https://visibility.is',
      'twitter:card': 'summary',
      'twitter:title': 'visibility.is — Look behind the curtain before you join a company',
      'twitter:description': 'Bridge the gap between PR/recruiting pitches and workplace reality.',
      'twitter:image': 'https://cdn.magicpatterns.com/uploads/nXQwxbHUw9VppBjvNZBCE4/favicon.png'
    };
    Object.entries(metaTags).forEach(([name, content]) => {
      const isOg = name.startsWith('og:') || name.startsWith('twitter:');
      const attr = isOg ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    });
    // Set favicon programmatically
    let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/nXQwxbHUw9VppBjvNZBCE4/favicon.png';
    link.type = 'image/png';
  }, []);
  return <TooltipProvider delayDuration={200} data-id="element-0">
      <div className="min-h-screen flex flex-col bg-background text-foreground font-heading" data-id="element-1">
        <Header data-id="element-2" />
        <QuickQuestions data-id="element-3" />
        <div className="flex flex-1 overflow-hidden" data-id="element-4">
          <FilterSidebar data-id="element-5" />
          <CompanyDirectory data-id="element-6" />
        </div>
      </div>
    </TooltipProvider>;
}